import React from "react";
import {PatternBackground} from "../../components/PatternBackground";

export const NotificationPage = () => {
  return (
      <div className="">
        <PatternBackground>
          <p className="lead fw-bold">Notifications</p>
          <small>View  all notifications scheduled</small>
        </PatternBackground>
          <div className="om-container">
            <div className="row align-items-center">
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-3">
                  <p className="lead fw-bold mb-2 mt-5">Filters</p>
                  <small>See your notifications here</small>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                  <div className="dropdown float-end">
                      <button className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i className="bi bi-filter"/> Filter</button>
                      <ul className="dropdown-menu">
                          <li><button className="dropdown-item" type="button">Week</button></li>
                          <li><button className="dropdown-item" type="button">Month</button></li>
                          <li><button className="dropdown-item" type="button">Year</button></li>
                      </ul>
                  </div>
              </div>
          </div>
            <div className='p-5 shadow-sm bg-white rounded'>
          <div className='mt-5'>
            <p className="mb-4">Today</p>
              <div className="row mb-5">
                  <div className="col-1">
                      <span><span className="badge bg-success fw-bold p-2"><i className="bi bi-bell" style={{fontSize:'14px'}}/></span></span>
                  </div>
                  <div className="col-11">
                      <p className='mb-2 text-black-50'>Please upload the pension schedule for July</p>
                      <small className=' text-black-50'>29 August 2022 at 12:20pm</small>
                  </div>
              </div>
              <div className="row mb-5">
                  <div className="col-1">
                      <span><span className="badge bg-success fw-bold p-2"><i className="bi bi-bell" style={{fontSize:'14px'}}/></span></span>
                  </div>
                  <div className="col-11">
                      <p className='mb-2 text-black-50'>Please upload the pension schedule for July</p>
                      <small className=' text-black-50'>29 August 2022 at 12:20pm</small>
                  </div>
              </div>
              <div className="row mb-5">
                  <div className="col-1">
                      <span><span className="badge bg-success fw-bold p-2"><i className="bi bi-bell" style={{fontSize:'14px'}}/></span></span>
                  </div>
                  <div className="col-11">
                      <p className='mb-2 text-black-50'>Please upload the pension schedule for July</p>
                      <small className=' text-black-50'>29 August 2022 at 12:20pm</small>
                  </div>
              </div>
          </div>
        </div>
          </div>
      </div>
  )
}